import type { Interpolation, Theme } from '@emotion/react';
import { Chip, Flex } from '@inflearn/ds-react';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';
import { MY_URL } from '../../../../constants/urls';
import { CourseRegistrationManagerLayout } from './CourseRegistrationManagerLayout';

export function GiftPageLayout({
  children,
  title,
  description,
}: {
  children: ReactNode;
  title: string;
  description: string;
}) {
  return (
    <CourseRegistrationManagerLayout title={title} description={description}>
      <GiftPageLayoutTabs styles={{ marginBottom: 16 }} />
      {children}
    </CourseRegistrationManagerLayout>
  );
}

function GiftPageLayoutTabs({ styles }: { styles: Interpolation<Theme> }) {
  const router = useRouter();

  return (
    <Flex gap={10} css={styles}>
      <Chip
        variant="outline"
        color="gray"
        size="xs"
        checked={router.pathname === new URL(MY_URL.GIFTS_RECEIVED()).pathname}
        radius="xl"
        onClick={() => {
          router.push(MY_URL.GIFTS_RECEIVED(), undefined, { shallow: true });
        }}
      >
        받은 선물
      </Chip>
      <Chip
        variant="outline"
        color="gray"
        size="xs"
        checked={router.pathname === new URL(MY_URL.GIFTS_SENT()).pathname}
        radius="xl"
        onClick={() => {
          router.push(MY_URL.GIFTS_SENT(), undefined, { shallow: true });
        }}
      >
        보낸 선물
      </Chip>
    </Flex>
  );
}
